import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a Date object to YYYY-MM-DD string in LOCAL timezone
 * This prevents timezone shift issues where dates appear one day off
 * @param {Date} date - The date object to format
 * @returns {string} Date string in YYYY-MM-DD format
 */
export function formatDateLocal(date) {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Parse a YYYY-MM-DD string to a Date object in LOCAL timezone
 * Avoids UTC interpretation that causes day shifts
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {Date} Date object set to midnight local time
 */
export function parseDateLocal(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') {
    return new Date();
  }
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Get today's date as YYYY-MM-DD string in LOCAL timezone
 * @returns {string} Today's date string
 */
export function getTodayStr() {
  return formatDateLocal(new Date());
}
